// 自動生成。手で直さない。作り方は notes-sandbox/ops/art/public-3d/build.mjs
// 公開の頁に入れる立体感の型の絵 (コース詳細の旗の階段、つまずき辞典の札、ログインと登録の足もとの丘、よくある質問の 4 つの場面)。
// 絵は明るい版だけの SVG (公開の頁は OS が暗い設定でも地が明るいまま)。描き直すと中身のハッシュが変わり、別の名前になる (public は 1 年 immutable)。
export const PUB3D_ART = {
  "outcomes": {
    "3": "/assets/pub3d/outcomes-3.8c218e9f5e.svg",
    "4": "/assets/pub3d/outcomes-4.d4adb5e8f4.svg",
    "5": "/assets/pub3d/outcomes-5.83e696f532.svg",
    "6": "/assets/pub3d/outcomes-6.6682d99139.svg",
    "7": "/assets/pub3d/outcomes-7.927f95d2de.svg",
    "8": "/assets/pub3d/outcomes-8.3f99594428.svg",
    "9": "/assets/pub3d/outcomes-9.4a7c8a4b88.svg"
  },
  "mistakes": {
    "java-basics": "/assets/pub3d/mistakes-java-basics.9258168ae9.svg",
    "java-control-flow": "/assets/pub3d/mistakes-java-control-flow.2d1804c60c.svg",
    "java-loops-methods": "/assets/pub3d/mistakes-java-loops-methods.a2dcf404a7.svg",
    "java-arrays-collections": "/assets/pub3d/mistakes-java-arrays-collections.af45193cf8.svg",
    "java-oop": "/assets/pub3d/mistakes-java-oop.c2c20f116a.svg",
    "java-exceptions-io": "/assets/pub3d/mistakes-java-exceptions-io.cfb7d36ee6.svg",
    "java-standard-library": "/assets/pub3d/mistakes-java-standard-library.dce590e130.svg",
    "java-stream-functional": "/assets/pub3d/mistakes-java-stream-functional.c1249b8b08.svg",
    "java-intermediate": "/assets/pub3d/mistakes-java-intermediate.5ac82f9674.svg",
    "javascript-basics": "/assets/pub3d/mistakes-javascript-basics.8a11d119a4.svg",
    "javascript-core": "/assets/pub3d/mistakes-javascript-core.c7b06c9360.svg",
    "javascript-dom": "/assets/pub3d/mistakes-javascript-dom.4068f05197.svg",
    "javascript-async-api": "/assets/pub3d/mistakes-javascript-async-api.8040ef57ce.svg",
    "javascript-practical": "/assets/pub3d/mistakes-javascript-practical.6cb9fc0bc4.svg",
    "python-basics": "/assets/pub3d/mistakes-python-basics.630d5045a8.svg",
    "python-operators-control": "/assets/pub3d/mistakes-python-operators-control.75e34ba368.svg",
    "python-loops-functions": "/assets/pub3d/mistakes-python-loops-functions.9eb4a5b10b.svg",
    "python-collections": "/assets/pub3d/mistakes-python-collections.a736146fc1.svg",
    "python-files-errors-project": "/assets/pub3d/mistakes-python-files-errors-project.eef2132ebf.svg"
  },
  "mistakeFallback": {
    "java": "/assets/pub3d/mistakes-fallback-java.9258168ae9.svg",
    "javascript": "/assets/pub3d/mistakes-fallback-javascript.8a11d119a4.svg",
    "python": "/assets/pub3d/mistakes-fallback-python.630d5045a8.svg",
    "other": "/assets/pub3d/mistakes-fallback-other.5875bf470a.svg"
  },
  "faq": {
    "money": "/assets/pub3d/faq-money.7ceaca5fba.svg",
    "start": "/assets/pub3d/faq-start.55f6240fab.svg",
    "learn": "/assets/pub3d/faq-learn.55807609d8.svg",
    "help": "/assets/pub3d/faq-help.4192c01b95.svg"
  },
  "authHill": {
    "login": "/assets/pub3d/auth-hill-login.87ed690e00.svg",
    "signup": "/assets/pub3d/auth-hill-signup.cadf697c53.svg"
  }
} as const;
